"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberInfoRequest = void 0;
var MemberInfoRequest = /** @class */ (function () {
    function MemberInfoRequest() {
    }
    return MemberInfoRequest;
}());
exports.MemberInfoRequest = MemberInfoRequest;
;
//# sourceMappingURL=memberInfo.request.js.map